import Other from './other'
import OtherPageQuery, {
  OTHER_QUERY,
  OTHER_PAGE_QUERY,
  OTHER_PROMO_QUERY,
  fetchOtherSSRData,
} from './other.query'

export {
  OtherPageQuery,
  OTHER_QUERY,
  OTHER_PAGE_QUERY,
  OTHER_PROMO_QUERY,
  fetchOtherSSRData,
}

export default Other
